module.exports = __webpack_public_path__ + "static/img/diamond.a16856e8.png";